import styled, { keyframes, css } from 'styled-components';
export var MarqueeContainer = styled.div.withConfig({
  displayName: "Marqueestyles__MarqueeContainer",
  componentId: "sc-a15lpe-0"
})(["overflow-x:hidden !important;display:flex !important;flex-direction:row !important;position:relative;width:100%;&:hover div{animation-play-state:", ";}&:active div{animation-play-state:", ";}"], function (props) {
  return props.pauseOnHover;
}, function (props) {
  return props.pauseOnHover;
});
var backgroundGradient = css(["background:linear-gradient( to right,#ffffff00 90%,", " 100% );"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.backgroundPrimary;
});
export var Overlay = styled.div.withConfig({
  displayName: "Marqueestyles__Overlay",
  componentId: "sc-a15lpe-1"
})(["position:absolute;width:100%;height:100%;pointer-events:none;&::before{", " content:'';height:100%;position:absolute;width:100%;z-index:2;}&::before{left:0;top:0;}"], backgroundGradient);
var scroll = keyframes(["0%{transform:translateX(0%);}80%{transform:translateX(-100%);}100%{transform:translateX(-100%);}"]);
var complexAnimation = css(["animation:", " ", " linear ", " infinite;"], scroll, function (props) {
  return props.duration;
}, function (props) {
  return props.delay;
});
export var Marquee = styled.div.withConfig({
  displayName: "Marqueestyles__Marquee",
  componentId: "sc-a15lpe-2"
})(["flex:0 0 auto;min-width:100%;z-index:1;display:flex;flex-direction:row;align-items:center;", ";animation-play-state:", ";animation-delay:", ";animation-direction:normal;"], complexAnimation, function (props) {
  return props.play;
}, function (props) {
  return props.delay;
});